import { useContext } from 'react';
import { Stack } from 'shell/components';
import { SettingsPageContext } from '../../PageProvider';
import { PreferenceProvider } from '../../Preferences';
import { PREFERENCES_GROUP_ID } from '../../sectionRegistry';
import Billing from './Billing';
import ChangePassword from './ChangePassword';
import CourseDetails from './CourseDetails';
import EditProfile from './EditProfile';
import Feedback from './Feedback';
import Grading from './Grading';
import InlineComments from './InlineComments';
import InterfaceLanguage from './InterfaceLanguage';

const SECTION_COMPONENT_BY_ID = {
    'edit-profile': EditProfile,
    'change-password': ChangePassword,
    billing: Billing,
    'interface-language': InterfaceLanguage,
    'course-details': CourseDetails,
    grading: Grading,
    feedback: Feedback,
    'inline-comments': InlineComments,
};

const renderSections = (sections) =>
    sections.map(({ id }) => {
        const Section = SECTION_COMPONENT_BY_ID[id];
        if (!Section) throw new Error(`Missing settings section component for "${id}".`);
        return <Section key={id} sectionId={id} />;
    });

const SettingsSections = () => {
    const { groups, setSectionDirty } = useContext(SettingsPageContext);
    const nonPreferenceSections = groups
        .filter(({ id }) => id !== PREFERENCES_GROUP_ID)
        .flatMap(({ sections }) => sections);
    const preferenceSections = groups.find(({ id }) => id === PREFERENCES_GROUP_ID)?.sections || [];

    return (
        <Stack spacing={9} sx={{ minWidth: 0, width: '100%' }}>
            {renderSections(nonPreferenceSections)}
            {preferenceSections.length > 0 && (
                <PreferenceProvider onDirtyChange={(value) => setSectionDirty(PREFERENCES_GROUP_ID, value)}>
                    <Stack spacing={9}>{renderSections(preferenceSections)}</Stack>
                </PreferenceProvider>
            )}
        </Stack>
    );
};

export default SettingsSections;
